import Catalogo from '../Catalogo';

const CatalogoPage = () => <Catalogo />;

export default CatalogoPage;
